import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import * as SerializationApi from '@/app/state-serialization/api';
import AccordionComponent from "./accordion-component.vue";
import { AccordionStateProtobufSerializer } from "./accordion-state-protobuf-serializer";
import { IncludeAccordionHandler } from './include-accordion-handler'

export const accordionFactoryModule = new ContainerModule(bind => {
  bind<Api.InteractiveComponentPlugin>(Api.InteractiveComponentPluginSymbol)
    .toConstantValue(AccordionComponent)
    .whenTargetNamed("accordion");

  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeAccordionHandler);

  bind(SerializationApi.StateSerializationPluginSymbol).to(AccordionStateProtobufSerializer)
});
